import { getJson, postJson } from 'api/baseApi'

export const getAttachmentFilesList = function (conceptId, userId, hashValue, source) {
  if (source === undefined) { source = 'notification' }
  let url = '/api/server/comments/getattachments/' + conceptId + '/' + userId + '/' + hashValue + '/' + source
  return new Promise((resolve, reject) => {
    getJson({ url, data: null }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const getFileDownloadLink = function (conceptId, filename, fileId) {
  let concept = {CommentId: conceptId, FileName: filename, FileId: fileId}
  let url = '/api/server/comments/downloadattachment/'
  return new Promise((resolve, reject) => {
    postJson({ url, data: concept }).then(response => {
      resolve(response)
    }).catch(error => reject(error))
  })
}

export const downloadFile = function (url) {
  window.open(url, '_blank')
}



// WEBPACK FOOTER //
// ./src/api/commentApi.js